function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_214",
  "data-name": "Group 214",
  transform: "translate(-1015.755 -190.267)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Inteligentny_obiekt_wektorowy",
  "data-name": "Inteligentny obiekt wektorowy",
  width: 20,
  height: 20,
  transform: "translate(1016.255 190.767)",
  fill: "none",
  stroke: "#ffff00",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_109",
  "data-name": "Line 109",
  x2: 9,
  y2: 9,
  transform: "translate(1021.5 195.5)",
  fill: "none",
  stroke: "#ffff00",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_110",
  "data-name": "Line 110",
  x1: 9,
  y2: 9,
  transform: "translate(1021.5 195.5)",
  fill: "none",
  stroke: "#ffff00",
  strokeWidth: 1
}));

var SvgCloseIconYellow = function SvgCloseIconYellow(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCloseIconYellow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/close-icon-yellow.d496e6a7.svg";
export { ForwardRef as ReactComponent };